import React from 'react';
import './PrintablePriceList.css'; // Assuming a similar CSS file structure
import { format } from 'date-fns';

// Interfaces based on data structure from report.controller.js generatePriceList
interface PriceListItem {
  id: number;
  code: string;
  type: string;
  location: string;
  dimensions?: string | null;
  isLED: boolean;
  dailyPrice: number;
  monthlyPrice: number;
}

interface PriceListData {
  structures: PriceListItem[];
  validUntil: Date | string;
}

interface PrintablePriceListProps {
  priceListData: PriceListData;
}

// Helper to format dates
const formatDate = (date: Date | string | null | undefined): string => {
  if (!date) return 'N/A';
  try {
    return format(new Date(date), 'dd.MM.yyyy');
  } catch (e) {
    return 'Invalid Date';
  }
};

// Helper to format currency
const formatCurrency = (value: number | null | undefined): string => {
  if (value === undefined || value === null) return '0 ₸';
  return new Intl.NumberFormat('ru-KZ', {
    style: 'currency',
    currency: 'KZT',
    minimumFractionDigits: 0, // No decimals for price list
    maximumFractionDigits: 0,
  }).format(value);
};

const PrintablePriceList: React.FC<PrintablePriceListProps> = ({ priceListData }) => {
  if (!priceListData || !priceListData.structures) {
    return <div className="printable-container">Ошибка: Данные для прайс-листа не найдены.</div>;
  }

  const { structures, validUntil } = priceListData;

  return (
    <div className="printable-container price-list-container">
      <header className="printable-header">
        <h1>Прайс-лист на размещение рекламы</h1>
        <p>Действителен до: {formatDate(validUntil)}</p>
      </header>

      <section className="details-table">
        <table>
          <thead>
            <tr>
              <th>Код</th>
              <th>Тип</th>
              <th>Локация</th>
              <th>Размеры</th>
              <th>Цена (День)</th>
              <th>Цена (Месяц)</th>
            </tr>
          </thead>
          <tbody>
            {structures.map((structure) => (
              <tr key={structure.id}>
                <td>{structure.code}</td>
                <td>{structure.type}{structure.isLED ? ' (LED)' : ''}</td>
                <td>{structure.location}</td>
                <td>{structure.dimensions || '-'}</td>
                <td>{formatCurrency(structure.dailyPrice)}</td>
                <td>{formatCurrency(structure.monthlyPrice)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <footer className="printable-footer">
        <p>Цены указаны в тенге (KZT) с учетом НДС. Возможны скидки в зависимости от объема и срока размещения.</p>
        <p>ТОО "Рекламное агентство SignageAgency" | {formatDate(new Date())}</p>
      </footer>
    </div>
  );
};

export default PrintablePriceList;
